import {Component, Input, OnInit} from '@angular/core';
import {ZaverecnaPraca} from '../model/zaverecnaPraca';
import {AppService} from '../app.service';
import {Studium} from '../model/studium';

@Component({
    selector: 'app-zaverecne-prace',
    templateUrl: './zaverecne-prace.component.html',
    styleUrls: ['./zaverecne-prace.component.css'],
    standalone: false
})
export class ZaverecnePraceComponent implements OnInit {

  @Input()
  zaverecnePrace: ZaverecnaPraca[];

  @Input()
  studium: Studium;

  constructor(private appService: AppService) { }

  ngOnInit() {
  }

  openPrehladZaverecnychPrac() {
    this.appService.openPortalAppWindow(
      'ais.gui.vs.es.VSES382_ZoznamZadaniZaverecnychPracDlg',
      this.studium.id
    );
  }
}
